import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const checkedStyles = {
  bg: 'white',
  borderColor: 'black',
  color: 'black'
};

const baseStyle = definePartsStyle({
  control: {
    _checked: {
      ...checkedStyles,
      _hover: checkedStyles
    }
  }
});

const radioCard = definePartsStyle({
  label: {
    width: '100%'
  }
});

export const Radio = defineMultiStyleConfig({
  baseStyle,
  variants: {
    radioCard
  }
});